export default "__VITE_ASSET__DZKQrerQ__"